import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Header from '../components/Header';
import Hero from '../components/Hero';
import AboutUs from '../components/AboutUs';
import Journey from '../components/Journey';
import Programs from '../components/Programs';
import Benefits from '../components/Benefits';
import Testimonials from '../components/Testimonials';
import Leadership from '../components/Leadership';
import FAQ from '../components/FAQ';
import Footer from '../components/Footer';

function HomePage() {
  const { hash } = useLocation();

  useEffect(() => {
    if (!hash) return undefined;
    const id = hash.replace('#', '');

    const timer = window.setTimeout(() => {
      const el = document.getElementById(id);
      if (!el) return;

      const header = document.querySelector('header');
      const headerHeight = header?.getBoundingClientRect().height ?? 96;
      const offset = headerHeight + 16;
      const top = el.getBoundingClientRect().top + window.scrollY - offset;

      window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    }, 80);

    return () => window.clearTimeout(timer);
  }, [hash]);

  return (
    <div className="min-h-screen bg-brand-white font-sans">
      <Header />
      <main>
        <section id="home">
          <Hero />
        </section>
        <AboutUs />
        <Journey />
        <Programs />
        <Benefits />
        <Testimonials />
        <Leadership />
        <FAQ />
      </main>
      <Footer />
    </div>
  );
}

export default HomePage;
